import React, { useState } from 'react';
import { closeEventModal } from '../../utils/functions';
import apiService from '../../services/api';

const EventModal = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    company_name: '',
    designation: ''
  });
  const [loading, setLoading] = useState(false);
  const [eventType, setEventType] = useState('');

  React.useEffect(() => {
    // Listen for event type changes
    const checkEventType = () => {
      const eventTypeInput = document.getElementById('event-type');
      if (eventTypeInput) {
        setEventType(eventTypeInput.value);
      }
    };

    const interval = setInterval(checkEventType, 100);
    return () => clearInterval(interval);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Mobile number validation - only digits, max 10
    if (name === 'mobile') {
      const mobileValue = value.replace(/[^0-9]/g, '').slice(0, 10);
      setFormData({
        ...formData,
        [name]: mobileValue
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate mobile number
    const mobileClean = formData.mobile.replace(/\D/g, '');
    if (mobileClean.length !== 10) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }
    
    setLoading(true);

    const submitFormData = new FormData();
    Object.keys(formData).forEach(key => {
      submitFormData.append(key, formData[key]);
    });
    submitFormData.append('event_type', eventType);

    try {
      const result = await apiService.submitEventRegistration(submitFormData);
      if (result.success) {
        alert('Thank you for your registration! We will contact you shortly.');
        setFormData({
          name: '',
          email: '',
          mobile: '',
          company_name: '',
          designation: ''
        });
        closeEventModal();
      } else {
        alert(result.message || 'Error submitting registration. Please try again.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const getEventTitle = () => {
    const titles = {
      'synergy-meet': 'Synergy Meet West Zone Registration',
      'elite-buyer': 'Elite Buyer Club Registration',
      'channel-partner': 'Channel Partner Meet Registration',
      'supplier-meet': 'Supplier Meet Registration'
    };
    return titles[eventType] || 'Event Registration';
  };

  return (
    <div id="event-modal" className="modal" style={{ display: 'none' }} onClick={(e) => {
      // Close modal when clicking on backdrop
      if (e.target.id === 'event-modal') {
        closeEventModal();
      }
    }}>
      <div className="modal-content">
        <span className="close-modal" onClick={closeEventModal}>&times;</span>
        <h2 id="modal-title">{getEventTitle()}</h2>
        <form id="event-registration-form" onSubmit={handleSubmit}>
          <input type="hidden" id="event-type" name="event_type" value={eventType} />
          <div className="form-group">
            <label>Name *</label>
            <input 
              type="text" 
              name="name" 
              placeholder="Enter your full name"
              required
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Company Name</label>
            <input 
              type="text" 
              name="company_name"
              placeholder="Enter your company name"
              value={formData.company_name}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Designation</label>
            <input 
              type="text" 
              name="designation"
              placeholder="Enter your designation"
              value={formData.designation}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Mobile No *</label>
            <input 
              type="tel" 
              name="mobile" 
              placeholder="Enter 10-digit mobile number"
              maxLength={10}
              inputMode="numeric"
              pattern="[0-9]{10}"
              required
              value={formData.mobile}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Email Id *</label>
            <input 
              type="email" 
              name="email" 
              placeholder="Enter your email address"
              required
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Registering...
              </>
            ) : (
              'Register'
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EventModal;

